<template>
  <div id="user-header">
    <Toolbar>
      <template #start>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <BasicButton
              v-if="user"
              id="menu-button"
              icon="pi pi-bars"
              class="me-2 menu-button bg-white border-0"
              need-icon
              variant="secondary"
              large
              @click="showHeader = !showHeader"
            />
            <h6 class="d-flex align-items-center">
              <PageTree
                v-if="overwriteTree?.length || pageTree?.length"
                :tree="overwriteTree || pageTree"
              />
              <b
                id="user-page-header-title"
                style="border-bottom: 2px solid #999"
                >{{ overwriteTitle || pageTitle }}</b
              >
            </h6>
          </div>
        </div>
      </template>
      <template #end>
        <!--
        <div class="d-flex align-items-center px-2">
          <router-link
            :to="{ name: 'Index' }"
            class="me-3 text-decoration-underline"
          >
            <BasicButton
              label="TOP"
              variant="secondary"
              icon="pi pi-home"
              need-icon
            />
          </router-link>
          <div v-if="user" class="d-flex align-items-center">
            <i class="pi pi-user me-2"></i>
            <span>{{ user.email }}</span>
          </div>
        </div>
        -->
      </template>
    </Toolbar>
    <Divider class="m-0 px-0" />
    <Sidebar v-if="user" v-model:visible="showHeader" id="user-header-sidebar">
      <PanelMenu
        id="user-panel-menu"
        :model="headerItems"
        v-model:expanded-keys="expandedKeys"
        multiple
        class="without-border w-100"
      />
    </Sidebar>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from "vue";
import { treeSearch } from "/@/modules/json";
import { BasicButton } from "/@/vue/components/Atom";
import { PageTree } from "/@/vue/components/Layouts";
import { useRouterUtil, useAuthorize, useUser } from "/@/vue/composables";
import Sidebar from "primevue/sidebar";
import PanelMenu from "primevue/panelmenu";
import Toolbar from "primevue/toolbar";
import Divider from "primevue/divider";
import type { MenuItem } from "primevue/menuitem";
import { Invest24RecruitmentType, UserClient } from "/@/types";

interface Props {
  user?: UserClient;
  isAdminPage?: boolean;
  overwriteTitle?: string;
  overwriteTree?: {
    name: string;
    title: string;
    query?: Record<string, any>;
  }[];
}

const props = defineProps<Props>();
defineEmits(["logout", "hideHeader"]);

const showHeader = ref<boolean>(false);

const { goto, reload, currentRouteMeta, currentRouteQuery, currentRouteName } =
  useRouterUtil();
const {
  isAllManager,
  isAllPoster,
  isVManager,
  isOwner,
  isOffice,
  isOrganizationManager,
  isIManager,
  isABCManager,
  isABCPoster,
  isUserManager,
  isAllLManager,
  isBcpManager,
  isRuleManager,
  isDManager,
  isSomeManager,
  headerItems,
} = useUser();

const recruitmentType = computed(() => {
  return (
    (currentRouteQuery.value.recruitmentType as Invest24RecruitmentType) ||
    "invest24"
  );
});

const pageTitle = computed(() => {
  return currentRouteMeta.value?.title;
});

const pageTree = computed(() => {
  return currentRouteMeta.value?.tree || [];
});

function commandHandler(command: () => void) {
  return () => {
    command();
    showHeader.value = false;
  };
}

// header items

const expandedKeys = ref<Record<string, any>>({});

function expandNode(node: { key: string; items?: MenuItem[] }) {
  if (node && node.items && node.items.length) {
    expandedKeys.value[node.key] = true;

    for (let child of node.items as (MenuItem & { key: string })[]) {
      expandNode(child);
    }
  }
}

onMounted(() => {
  let key = currentRouteName.value;

  if (key === "UsersRecruitmentsManagementsManagement") {
    if (!recruitmentType.value) {
      key = "UsersRecruitmentsManagementsManagementInvest24";
    } else {
      key = `UsersRecruitmentsManagementsManagement${recruitmentType.value[0].toUpperCase()}${recruitmentType.value.slice(
        1
      )}`;
    }
  }

  if (!key) return;

  let targetTree = undefined;

  headerItems.value.forEach((item) => {
    if (!targetTree) {
      targetTree = treeSearch({ key: "key", value: key }, item);
    }
  });

  expandNode(targetTree);
});

// logout

const { logout } = useAuthorize();

async function handleLogout() {
  await logout();
  reload();
}
</script>

<style lang="scss" scoped>
#header {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  color: $main-gray-color;
  background-color: white;

  .p-toolbar {
    padding: 0;
  }

  .p-button {
    border: none;
  }

  .menu-button {
    background-color: inherit;
    //border: 1px solid lightgray;
    .pi {
      font-size: 1.5rem;
    }
  }
}
</style>

<style lang="scss">
#user-header-sidebar {
  .p-menuitem-active {
    a {
      background-color: beige;
    }
  }
}

.p-sidebar-left .p-sidebar {
  width: 23rem;
}
</style>
